<button *ngIf="activeKeynote.partOfCollection" routerLink=".." class="fullsize-button" id="top">
  {{ collection.backButtonText }} 
</button>
<div class="col-3-4" id="stream">
  <app-custom-stream
    *ngIf="activeKeynote.streamingTool === StreamingTool.CustomRTMP"
    class="card"
    [URL]="activeKeynote.customStreamURL"
    [StreamID]="activeKeynote.customStreamID"
    [Suffix]="activeKeynote.customStreamSuffix"
  ></app-custom-stream>
  <app-theoplayer
    *ngIf="activeKeynote.streamingTool === StreamingTool.Wowza"
    [streamSrc]="activeKeynote.customStreamID"
    class="card"
  ></app-theoplayer>
  <app-contenflow
    *ngIf="activeKeynote.streamingTool === StreamingTool.Contentflow"
    [outputId]="activeKeynote.customStreamID"
    class="card"
  ></app-contenflow>
  <app-three-q
    *ngIf="activeKeynote.streamingTool === StreamingTool.THREEQ"
    [outputId]="activeKeynote.customStreamID"
    class="card"
  ></app-three-q>
  <div class="partners" *ngIf="activeKeynote.partners">
    <app-partners [partnersUrl]="activeKeynote.partners" [partnerLink]="activeKeynote.partnerLink"></app-partners>
  </div>
</div>
<div class="col-1-4" id="slido" *ngIf="activeKeynote.interactionTool !== InteractionTool.NotLoaded">
  <app-slido *ngIf="activeKeynote.interactionTool === InteractionTool.Slido" class="card" [eventID]="activeKeynote.slidoEventId">
  </app-slido>
  <app-voxr *ngIf="activeKeynote.interactionTool === InteractionTool.Voxr" class="card" [voxrEventID]="activeKeynote.voxrEventID">
  </app-voxr>
  <app-slido *ngIf="activeKeynote.interactionTool === InteractionTool.iFrame" class="card" [iframeUrl]="activeKeynote.iframeLink">
  </app-slido>
</div>
